export const USER_ROLES = {
  USER: "USER",
  SUPER_USER: "SUPER_USER",
};

export const TOKEN_TYPE = {
  // Aad: 0,
  Embed: 1,
};

export const FILTERS_OPERATIONS = {
  // RemoveAll: 0,
  ReplaceAll: 1,
  // Add: 2,
  // Replace: 3
};

export const POWER_BI_SETTINGS = {
  navContentPaneEnabled: false,
};

export const POWER_BI_ALLOWED_ROUTES = [
  "/promotions",
  "/promotions?createPromo=true",
];

export const OFFLINE_CRS_ID = 4;
export const OMNIBEES_CRS_ID = 19;
export const D_EDGE_CRS_ID = 10;

// ARI fetch batching: properties with up to ARI_BATCH_THRESHOLD room types are
// fetched in a single request; larger properties fetch sequentially in groups
// of ARI_BATCH_SIZE, the selected room type's batch first.
export const ARI_BATCH_SIZE = 10;
export const ARI_BATCH_THRESHOLD = 10;
